import _extends from "@babel/runtime/helpers/extends";
import React from "react";
import { Modal as CoreModal } from "@vds-core/modals";
import { IconData } from "@vds/icons";
import { colors } from "@vds/theme";

var Modal = function Modal(props) {
  function _calcPadding(viewport) {
    if (viewport === "mobile") {
      return "0px 0px 0px 12px";
    } else {
      return "48px 0px 46px 42px";
    }
  }

  function _calcWrapperPadding(viewport) {
    if (viewport === "mobile") {
      return "16px 16px 16px 4px";
    } else {
      return "0px 0px 2px 4px";
    }
  }

  var styleConfig = {
    modalDialogWrapper: {
      minHeight: "136px",
      calcPadding: _calcWrapperPadding,
      mobilePadding: true
    },
    modalDialog: {
      calcPadding: _calcPadding,
      //function taking viewport and padding is 16/48
      minHeight: "100%",
      defaultHeight: "70vh",
      modalWidth: "560px",
      mobileHeight: "100%"
    },
    modalOverlay: {
      noMobilePadding: true
    },
    modalCloseButton: {
      top: "0px",
      right: "0px",
      height: "48px",
      width: "48px",
      interactiveStates: true,
      backgroundColor: props.inverted ? colors.black : colors.white,
      iconData: IconData,
      size: "large"
    }
  };
  var animationDistance = 0.08 * Math.min(window.innerWidth, window.innerHeight);
  return /*#__PURE__*/React.createElement(CoreModal, _extends({}, props, {
    customScroll: true,
    preventBackButton: true,
    fixedCloseButton: true,
    colorConfig: colors,
    fullScreenDialog: props.fullScreenDialog,
    styleConfig: styleConfig,
    animationDistance: animationDistance
  }));
};

export default Modal;